module.exports = __webpack_public_path__ + "img/identity.fd0c7449.png";